module.exports = __webpack_public_path__ + "img/movable-arrow-up.b4991c5e.svg";